module.exports = __webpack_public_path__ + "sunsemweb/img/mmap.53b858fd.png";